export enum StatusConstant {
  STATUS_CREATED = 'STATUS_CREATED',
  STATUS_QUEUED = 'STATUS_QUEUED',
  STATUS_PRE_FLIGHT = 'STATUS_PRE_FLIGHT',
  STATUS_IN_PROGRESS = 'STATUS_IN_PROGRESS',
  STATUS_COMPLETED = 'STATUS_COMPLETED',
  STATUS_PAUSED = 'STATUS_PAUSED',
}

export enum Status {
  SUCCESS = 'SUCCESS',
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILURE = 'FAILURE',
}
